import React from 'react';
import { Card, CardContent } from './ui/card';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

// Memoized product metric card component for performance
const ProductMetricCard = React.memo(({
  title,
  value,
  onClick,
  color = 'text-primary',
  bgColor = 'bg-muted',
  borderColor = 'border-gray-200',
  tooltipTitle,
  isClickable = true
}) => {
  const cardContent = (
    <Card
      className={`${bgColor} ${borderColor} border ${
        isClickable
          ? 'cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md focus-within:outline-2 focus-within:outline-primary focus-within:outline-offset-2'
          : ''
      }`}
      onClick={isClickable ? onClick : undefined}
      onKeyDown={isClickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      } : undefined}
      tabIndex={isClickable ? 0 : -1}
      role={isClickable ? "button" : "presentation"}
      aria-label={isClickable ? tooltipTitle : undefined}
    >
      <CardContent className="text-center py-4">
        <p className={`text-3xl font-bold ${color}`}>
          {value}
        </p>
        <p className="text-sm text-muted-foreground mt-1">
          {title}
        </p>
      </CardContent>
    </Card>
  );

  if (tooltipTitle) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {cardContent}
          </TooltipTrigger>
          <TooltipContent>
            <p>{tooltipTitle}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return cardContent;
});

ProductMetricCard.displayName = 'ProductMetricCard';

export default ProductMetricCard;
